import { getTranslation } from 'helpers/getTranslation';

export const GROUP_BY_COURSE = 'course';
export const GROUP_BY_LESSON_TYPE = 'lessonType';
export const GROUP_BY_STATUS = 'status';
export const GROUP_BY_NONE = 'none';

export type GroupByValue =
  | typeof GROUP_BY_COURSE
  | typeof GROUP_BY_LESSON_TYPE
  | typeof GROUP_BY_STATUS
  | typeof GROUP_BY_NONE;

export const DEFAULT_GROUP_BY: GroupByValue = GROUP_BY_COURSE;

export type GroupByOption = {
  label: string;
  value: GroupByValue;
};

export const GROUP_BY_OPTIONS: GroupByOption[] = [
  {
    label: getTranslation('courses_lessons_page.group_by.options.course'),
    value: GROUP_BY_COURSE,
  },
  {
    label: getTranslation('courses_lessons_page.group_by.options.lesson_type'),
    value: GROUP_BY_LESSON_TYPE,
  },
  {
    label: getTranslation('courses_lessons_page.group_by.options.status'),
    value: GROUP_BY_STATUS,
  },
  {
    label: getTranslation('courses_lessons_page.group_by.options.none'),
    value: GROUP_BY_NONE,
  },
];
